"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { ConnectionStatusProvider, QueryProvider as SharedQueryProvider, ApiProvider } from "@sukha/query";
import { ChromeExtensionLivenessReporter } from "@/components/main/ChromeExtensionLivenessReporter";
import { createWebApiFetcher } from "@/lib/api/webApiFetcher";
import { queryClient } from "@/lib/tanstack/queryClient";
export { isSessionEndpoint, SESSION_REQUEST_TIMEOUT_MS } from "@/lib/api/webApiFetcher";
export default function QueryProvider(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = createWebApiFetcher();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const fetcher = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChromeExtensionLivenessReporter />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <SharedQueryProvider client={queryClient}><ApiProvider fetcher={fetcher}><ConnectionStatusProvider>{t2}{children}</ConnectionStatusProvider></ApiProvider></SharedQueryProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}